/* eslint-disable arrow-body-style */
import React, { useRef, useEffect } from 'react';
import { cleanString } from 'helpers/RouteHelper';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'componentsV2/Icon';

import Styles from './Tab.module.scss';

const Tab = ({
  activeTab = false,
  autoSelectTab,
  dropdownOpen = false,
  isCarousel = false,
  onClickDropdown,
  onClickTab,
  options,
  scrollPosition,
  showDropdownIcon = false,
  theme = {},
  title,
}) => {
  const ref = useRef(null);
  useEffect(() => {
    const found = ['find', 'findshows'].includes(cleanString(window.location.pathname));
    if (found && autoSelectTab) {
      if (options?.length) {
        onClickDropdown(title, options[0].name);
      } else {
        onClickTab(title);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeTab && !isCarousel) {
      ref?.current?.scrollIntoView({ inline: 'nearest', block: 'center', behaviour: 'smooth' });
    }
  }, [activeTab, isCarousel]);

  if (!title) return null;
  return (
    <div
      style={{ transform: `translateX(${scrollPosition}px)` }}
      className={classNames(Styles.tabContainer, theme.tabContainer)}
    >
      <button
        className={classNames(
          Styles.tab,
          theme.tab,
          activeTab && Styles.selectedTab,
          activeTab && theme.selectedTab,
        )}
        type="button"
        onClick={() => onClickTab(title)}
        ref={ref}
        role="tab"
      >
        <div className={classNames(Styles.titleContainer, theme.titleContainer)}>
          <span>{title}</span>
          {showDropdownIcon && (
            <span
              className={classNames(
                Styles.dropdownIcon,
                theme.dropdownIcon,
                dropdownOpen && Styles.dropdownIconOpen,
              )}
            >
              <Icon icon="chevron" color={activeTab ? 'black' : 'white'} />
            </span>
          )}
        </div>
      </button>
    </div>
  );
};

Tab.propTypes = {
  activeTab: PropTypes.bool.isRequired,
  autoSelectTab: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
  isCarousel: PropTypes.bool,
  onClickDropdown: PropTypes.func,
  onClickTab: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  scrollPosition: PropTypes.number,
  showDropdownIcon: PropTypes.bool,
  theme: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
};

export default Tab;
